export default {
  userID(state) {
    return state.userID;
  },
  isLoggedIn(state) {
    return (
      (state.token !== null && state.token !== '' && state.token !== 'null') ||
      (localStorage.getItem('token') !== '' && localStorage.getItem('login_type') == 'student')
    );
  },
  token(state) {
    return localStorage.getItem('login_type') === 'student' && localStorage.getItem('token') !== ''
      ? localStorage.getItem('token')
      : state.token;
  },
  studentName(state) {
    return state.fname + ' ' + state.lname;
  },
  fName(state) {
    return state.fname;
  },
  lName(state) {
    return state.lname;
  },
  email(state) {
    return state.email;
  },
  school(state) {
    return state.school;
  },
  ctWhsEnabled(state) {
    return state.ctWhsEnabled;
  },
  preworkWorkplaceSafety(state) {
    return typeof state.prework !== 'undefined' &&
      state.prework !== null &&
      typeof state.prework.workplace_safety_url !== 'undefined'
      ? state.prework.workplace_safety_url
      : false;
  },
  preworkWorkplaceSafetyOther(state) {
    return typeof state.prework !== 'undefined' &&
      state.prework !== null &&
      typeof state.prework.workplace_safety_url_other !== 'undefined'
      ? state.prework.workplace_safety_url_other
      : false;
  },
  preworkWorkplacePreparationModules(state) {
    return typeof state.prework !== 'undefined' &&
      state.prework !== null &&
      typeof state.prework.workplace_preparation_modules_completed !== 'undefined'
      ? state.prework.workplace_preparation_modules_completed
      : false;
  },
  preworkApplicationType(state) {
    return typeof state.prework !== 'undefined' &&
      state.prework !== null &&
      typeof state.prework.application_type !== 'undefined'
      ? state.prework.application_type - 1
      : 0;
  },
  experiences(state) {
    return state.experiences;
  },
  activeExperienceID(state) {
    return state.active_experience_id;
  },
  activeExperience(state) {
    const activeExperienceID = state.active_experience_id;
    if (!activeExperienceID) return false;
    const experience = state.experiences.find((i) => i.id == activeExperienceID);
    return experience;
  },
  available_experiences(state) {
    return state.available_experiences;
  },
  certificate_teachers(state) {
    return state.certificate_teachers;
  },
  prework(state) {
    return state.prework;
  },
  preworkCompleted(state) {
    return (
      typeof state.prework !== 'undefined' &&
      state.prework !== null &&
      state.prework.status !== null &&
      state.prework.status.completed
    );
  },
  settings(state) {
    return state.settings;
  },
  notifications(state) {
    return state.notifications;
  },
  toast_timeout_seconds(state) {
    if (!state.user_settings) {
      return 6000;
    }

    return parseInt(state.user_settings.accessibility.toast_timeout_seconds, 10) * 1000;
  },
};
